import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import { createPaymentSettings, getPaymentSettings } from '../../graphql';

export const paymentsettingsApi = createApi({
    reducerPath: 'voucherSettingsApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getPaymentSettings: builder.query({
            query: (variables) => ({ body: getPaymentSettings, variables }),
            keepUnusedDataFor: Infinity,
            refetchOnMountOrArgChange: true,
            providesTags: ['getPaymentSettings'],
        }),
        createPaymentSettings: builder.mutation({
            query: (variables) => ({ body: createPaymentSettings, variables }),
            invalidatesTags: ['getPaymentSettings'],
        }),

    }),
});

export const { useCreatePaymentSettingsMutation, useGetPaymentSettingsQuery } = paymentsettingsApi;
